import React, { useState, useEffect } from 'react';
import { Loader2, Filter } from 'lucide-react';
import { api_base_url } from "config";

const ZyteSection = () => {
  const [zyteSpiders, setZyteSpiders] = useState([]);
  const [selectedZyteSpider, setSelectedZyteSpider] = useState("");
  const [loadingSpiders, setLoadingSpiders] = useState(false);
  const [loadingData, setLoadingData] = useState(false);
  const [showZyteOptions, setShowZyteOptions] = useState(false);

  useEffect(() => {
    const fetchZyteSpiders = async () => {
      setLoadingSpiders(true);
      try {
        const url = api_base_url + "/api/zyte/spiders/";
        const response = await fetch(url);
        const data = await response.json();
        setZyteSpiders(data.spiders || []);
      } catch (error) {
        console.error("Erro ao buscar spiders da Zyte:", error);
      } finally {
        setLoadingSpiders(false);
      }
    };

    if (showZyteOptions) {
      fetchZyteSpiders();
    }
  }, [showZyteOptions]);

  const handleFetchAndStoreZyteData = async () => {
    if (!selectedZyteSpider) {
      alert("Selecione um spider para buscar os dados!");
      return;
    }

    setLoadingData(true);
    try {
      const url = api_base_url + "/api/zyte/spiders/store/";
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Authorization: `Basic ${btoa("717270ba06ec4fbe91b05688ca93cf62:")}`,
        },
        body: new URLSearchParams({ spider: selectedZyteSpider }).toString(),
      });

      const data = await response.json();
      console.log("Resultado da Armazenagem:", data);
      alert(`Dados armazenados com sucesso! Criados: ${data.created}, Atualizados: ${data.updated}`);
    } catch (error) {
      console.error("Erro ao armazenar dados:", error);
      alert("Erro ao armazenar dados da Zyte");
    } finally {
      setLoadingData(false);
    }
  };

  return (
    <>
      {/* Botão para mostrar/ocultar opções da Zyte */}
      <button 
        onClick={() => setShowZyteOptions(!showZyteOptions)}
        className="inline-flex items-center justify-center rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 border border-input bg-background hover:bg-accent hover:text-accent-foreground h-9 px-4 py-2"
      >
        <Filter className="mr-2 h-4 w-4" />
        {showZyteOptions ? 'Ocultar Zyte' : 'Opções Zyte'}
      </button>

      {/* Seção Zyte - Expandível */}
      {showZyteOptions && (
        <div className="absolute top-full left-0 right-0 z-10 mt-1 px-4 py-3 bg-white border border-border rounded-md shadow-lg">
          <div className="flex flex-col md:flex-row items-start md:items-center gap-3">
            <div className="text-sm font-medium text-muted-foreground mb-2 md:mb-0">
              Integrações Zyte:
            </div>
            
            {/* Seletor de Spider da Zyte */}
            <div className="inline-flex items-center flex-grow">
              <select
                value={selectedZyteSpider}
                onChange={(e) => setSelectedZyteSpider(e.target.value)}
                className="rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring h-9 min-w-[250px]"
                disabled={loadingSpiders}
              >
                <option value="">Selecionar Spider Zyte</option>
                {loadingSpiders ? (
                  <option disabled>Carregando spiders...</option>
                ) : (
                  zyteSpiders.map((spider) => (
                    <option key={spider.id} value={spider.id}>
                      {spider.id}
                    </option>
                  ))
                )}
              </select>
            </div>
            
            {/* Botão para buscar dados do Spider selecionado */}
            <button 
              className="inline-flex items-center justify-center rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 bg-secondary text-secondary-foreground hover:bg-secondary/80 h-9 px-4 py-2"
              onClick={handleFetchAndStoreZyteData}
              disabled={loadingData}
            >
              {loadingData ? (
                <>
                  <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                  Buscando...
                </>
              ) : (
                "Buscar Dados"
              )}
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default ZyteSection;